import React from 'react';
import '../App.css';

export default function Banner(props) {
    return (
      <div id="banner">
         <img title="logo2" src="../images/cartonbarik.png" alt="the cart logo"/>
      </div>
    );
  }